<template>
    <div class="flex flex-col border rounded-xl dark:border-gray-800 aspect-[3]">
        <div class="p-4 md:p-5">
            <div class="flex items-center gap-x-2">
                <p class="text-sm font-semibold text-gray-500">{{ options.titulo }}</p>
            </div>
            <h3 class="mt-2 text-2xl sm:text-3xl lg:text-4xl text-gray-800 dark:text-gray-200">
            <span class="font-semibold">{{ options.cantidad }}</span> <span class="text-gray-500">/ {{ options.total }}</span>
            </h3>
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    options: any
}>()
</script>